import Flatpickr from "stimulus-flatpickr";
import "flatpickr/dist/themes/light.css";
// REFER:  https://npm.io/package/stimulus-flatpickr
// use below code in view part
// EX. <%= f.text_field :start_time, class: 'input', data: { controller: "flatpickr", flatpickr_min_date: Time.zone.now, date_format: 'd-M-Y'} %>
export default class extends Flatpickr {

}



